<template>
<div class="thal-page">
  <nav2 :title="title"></nav2>
  <div class="list-center">
    <div class="list-item">
      <div>{{$t('recordsBet.t_8')}}</div>
      <div>{{$t('recordsBet.t_9')}}</div>
      <div>{{$t('recordsBet.t_5')}}</div>
    </div>
    <div class="list-item"  v-for="(item,index) in details">
      <div>{{ item.playway_name }}</div>
      <div>{{ item.bet }}</div>
      <div>{{ item.win }}</div>
    </div>
  </div>
  <div class="list-cover">
    <div>{{ $t('recordsBet.t_2') }}：<span>{{ details.length}}</span></div>
    <div>{{ $t('recordsBet.t_11') }}：<span>{{  }}</span></div>
    <div>{{ $t('recordsBet.t_12') }}：<span>{{ list.bet_time }}</span></div>
    <div>{{ $t('recordsBet.t_4') }}：<span>{{ list.bet }}</span></div>
    <div>{{ $t('recordsBet.t_5') }}：<span>{{ list.profit }}</span></div>
    <div>{{ $t('recordsBet.t_13') }}：<span>0</span></div>
  </div>
</div>
</template>
<script>
import nav2  from "../THAL/navs.vue";
export default {
  name: "record_list",
  components:{nav2},
  data(){
    return{
      order_id:'',
      title:'',
      list:{},
      details:[],
    }
  },
  created() {
    let _self=this;
    if(_self.$route.query.id!='' && _self.$route.query.id!=undefined){
      _self.title=_self.$route.query.no;
      _self.order_id=_self.$route.query.id;
      _self._lottery_detail();
    }else{
      _self.$router.back();
    }
  },
  methods:{
    _lottery_detail:function (){
      let _self=this;
      this._PublicFun.getData('2', 'get', 'order/lottery/'+_self.order_id, {}, function (result) {
        if(result.data['status_code']==200){
          _self.list=result.data['data'];
          _self.details=_self.list.details;
        }

      })

    }
  }
}
</script>
<style scoped>
.list-center{
  display: block;
  width: 100%;
  margin: 55px auto 150px;
  padding: 0;
  max-width: 750px;
}
.list-item{
  display: flex;
  width: 96%;
  margin: 0 auto;
  padding: 10px 0;
  color: #FFFFFF;
  align-items: center;
  border-bottom: 1px solid #3F3F3F;
}
.list-item div{
  display: block;
  width: 33.3%;
  margin: 0 auto;
  padding: 0;
  text-align: center;
}
.list-item:first-child{
  border-bottom: 1px solid #787878;
  padding: 5px 0;
}
.list-item div:first-child{
  color: #F4D788;
}
.list-item:first-child div:first-child{
  color: #FFFFFF;
}
.list-cover{
  position: fixed;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  bottom: 0;
  background-color: #242424;
  height: 150px;
  max-width: 750px;

}
.list-cover div{
  display: block;
  width: 96%;
  margin: 0 auto;
  padding: 3px 0;
  clear: both;
  color: #FFFFFF;
  font-size: 12px;
}
.list-cover div span{
  float: right;
  font-size: 14px;
}
.list-cover div:first-child{
  margin-top: 8px;
}

</style>



// WEBPACK FOOTER //
// src/components/THAL/record_list.vue